/**
 * AVP returns measurement points that are not stored in BMR yet. Those rows carry no database id
 * (or a generated "NEW..." placeholder), so they have no details view and cannot be linked by id -
 * they have to be created first.
 */
export const isNotRegistered = (id) =>
  id === null || id === undefined || id === '' || String(id).startsWith('NEW');
